module.exports = __webpack_public_path__ + "img/d34cc64.jpg";